
export const DOMAIN_NAME = process.env.REACT_APP_DOMAIN_NAME;

const STORAGE_KEY = "nestpos.auth";

function deleteCookie(name, sd) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=." + DOMAIN_NAME;
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" + DOMAIN_NAME;
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain="+sd +"." + DOMAIN_NAME;
}

const setCookie = (name, value, days, sd) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/; domain=." + DOMAIN_NAME;
};
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

export function updatePlan(value) {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({ ...loadAuth(), company: { ...loadAuth("company"), plan: value } })
  );
}

export function saveAuthByKey(key = "", value = "") {
  if(key != null){
    const data = loadAuth();
    data[key] = value;
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(data)
    );
  }
}

export function saveAuth({ token, role, user, company }, setCookieFlag = false) {
  if(setCookieFlag){
    setCookie(STORAGE_KEY,JSON.stringify({ token, role, user, company }),1, company.subdomain);
  }
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({ token, role, user, company })
  );
}
export function loadAuth(key = "") {
  let x;
  try {
    var parsed = JSON.parse(localStorage.getItem(STORAGE_KEY));
    x = (key === "" ? parsed : parsed[key] ) || (key === "" ? {
      token: null,
      role: null,
      user: null,
      company: null,
    } : null);
  } catch {
    x = key === "" ? { token: null, role: null, user: null, company: null } : null;
  }
  if(x === null || (x.token === null)){
    x = getCookie(STORAGE_KEY);
    if(x){
      saveAuth(JSON.parse(x),false);
      
    }
  }
  return x;
}


export function clearAuth() {
  const sd = loadAuth("company")?.subdomain ?? "";
  deleteCookie(STORAGE_KEY, sd);
  localStorage.removeItem(STORAGE_KEY);
}

